import { GiftCard } from "@/dto/giftCard";
import { RetailCartItem } from "@/dto/retailCartItem";
import { ServiceCartItem } from "@/dto/serviceCartItem";
import { TableData } from "@/dto/tableData";
import pom from "@/utils/pom";
import { applyDataTestId } from "@/utils/testUtils";

export interface CartNumberProps {
  storedCart: RetailCartItem[] | ServiceCartItem[];
  storedGiftCard: GiftCard | null;
  merchantColor: string;
  tableData?: TableData | null;
}
export const CartNumber = ({
  storedCart,
  storedGiftCard,
  merchantColor,
  tableData,
}: CartNumberProps) => {
  const cartValue =
    storedCart.reduce((adder: number, item: any) => {
      if (item?.value?.serviceDetails?.priceType === "PER_UNIT") {
        return adder + 1;
      }
      return adder + (item?.value?.quantity || 0);
    }, 0) + (storedGiftCard ? 1 : 0);

  const scanToOrderCartLength = tableData?.order?.cart?.items?.length
    ? tableData?.order?.cart?.items?.length
    : 0;

  const shouldShow =
    storedCart.length > 0 || storedGiftCard || scanToOrderCartLength > 0;
  return (
    shouldShow && (
      <span
        data-testid={applyDataTestId(pom.header.cartNumber)}
        className="absolute flex left-2 top-2"
      >
        <div
          style={{ backgroundColor: merchantColor }}
          className="flex items-center justify-center text-white rounded-full w-5 h-5 text-xs"
        >
          {`${cartValue ? cartValue : "$"}`}
        </div>
      </span>
    )
  );
};
